// Types
import { LandingOptionsUtilsType } from './types/landing-options.utils.type';

const landingMethodIsSelected = <T>({
  selectedMethod,
  type,
}: LandingOptionsUtilsType<T>): boolean => type === selectedMethod;

export { landingMethodIsSelected };
